export default {
      id: "edit-pen-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#edit-pen",
      toString: function () {
        return this.url;
      }
    }